var map = {
	"./404-error.png": 4147,
	"./Kinetick_Logo.png": 6376,
	"./NinjaTrader_Wordmark_color_RGB.png": 1848,
	"./adv_01.png": 6807,
	"./adv_02.png": 4156,
	"./adv_03.png": 69,
	"./advantage1.svg": 1902,
	"./algo_icon.png": 4445,
	"./arrow-in-the-target-svgrepo-com.svg": 3012,
	"./background01.svg": 7247,
	"./blog/art1_big.png": 5758,
	"./blog/art1_min.png": 6096,
	"./blog/art2_big.png": 6465,
	"./blog/art2_int.png": 7712,
	"./blog/art2_min.png": 3759,
	"./blog/discord.png": 6137,
	"./blog/telegrama.png": 7871,
	"./card.png": 4678,
	"./chart02.png": 9888,
	"./check-svgrepo-com(1).svg": 8871,
	"./cumulative_icon.png": 4073,
	"./dc_mini.png": 4893,
	"./delta_icon.png": 4318,
	"./dm_mini.png": 2715,
	"./ds_mini.png": 4989,
	"./en.png": 4797,
	"./examples/ex-26-10-2021-ES.png": 7945,
	"./examples/ex-26-10-2021-En.png": 4700,
	"./examples/ex_04_11_en.png": 3287,
	"./examples/ex_04_11_es.png": 1442,
	"./examples/ex_05_03.png": 9811,
	"./examples/ex_05_03_02.png": 2550,
	"./examples/ex_06_10_2021_mes.png": 2506,
	"./examples/ex_06_10_2021_mes_esp.png": 3043,
	"./examples/ex_07_01_en.png": 6257,
	"./examples/ex_07_01_es.png": 1540,
	"./examples/ex_08_03.png": 8484,
	"./examples/ex_09_02_es.png": 1719,
	"./examples/ex_09_02_nq.png": 5024,
	"./examples/ex_10_10_es.png": 2098,
	"./examples/ex_10_10_ing.png": 8668,
	"./examples/ex_12-07-2021-CL.png": 7189,
	"./examples/ex_12_04_cl.png": 7424,
	"./examples/ex_12_11_en.png": 1390,
	"./examples/ex_12_11_es.png": 9483,
	"./examples/ex_15_04_2021_es.png": 120,
	"./examples/ex_15_04_cl1.png": 3382,
	"./examples/ex_15_04_cl2.png": 7149,
	"./examples/ex_15_04_cl3.png": 9668,
	"./examples/ex_30_11_en.png": 7874,
	"./examples/ex_30_11_es.png": 311,
	"./features/compra.jpg": 5284,
	"./features/momentum-en.png": 5478,
	"./features/momentum.png": 9544,
	"./features/operativa-crudo-en.gif": 8200,
	"./features/operativa-crudo-es.gif": 93,
	"./features/otm-algorithms.png": 1767,
	"./features/otm-algorithms2.png": 5797,
	"./features/otm-bar-timer-en.jpg": 1044,
	"./features/otm-bar-timer.jpg": 4534,
	"./features/otm-delta-bar-en.jpg": 4423,
	"./features/otm-delta-bar-free-en.jpg": 8250,
	"./features/otm-delta-bar-free.jpg": 7748,
	"./features/otm-delta-bar.jpg": 6703,
	"./features/otm-delta-cumulative-en.jpg": 4635,
	"./features/otm-delta-cumulative.jpg": 1635,
	"./features/otm-delta-micro-en.jpg": 7306,
	"./features/otm-delta-micro.jpg": 8244,
	"./features/otm-delta-swing-en.jpg": 8316,
	"./features/otm-delta-swing.jpg": 9086,
	"./features/otm-profile-en.jpg": 80,
	"./features/otm-profile.jpg": 2210,
	"./features/otm-vwap-en.jpg": 4923,
	"./features/otm-vwap.jpg": 6291,
	"./features/reversal-en.png": 8526,
	"./features/reversal.png": 6192,
	"./icons8-close.svg": 9307,
	"./id.jpg": 9995,
	"./ind_01.gif": 9368,
	"./ind_02.gif": 1343,
	"./ind_03.gif": 230,
	"./ind_04.gif": 9237,
	"./ind_05.gif": 4652,
	"./ind_06.gif": 6067,
	"./indicatorIcon.svg": 6914,
	"./indicators/OTM_ALGORITHMS.gif": 9659,
	"./indicators/OTM_CUMULATIVE.gif": 6444,
	"./indicators/OTM_DELTA_BAR.gif": 8659,
	"./indicators/OTM_DELTA_BAR_FREE.jpg": 4311,
	"./indicators/OTM_MICRO.gif": 8355,
	"./indicators/OTM_PROFILE.gif": 1920,
	"./indicators/OTM_SWING.gif": 9717,
	"./indicators/OTM_VWAP.gif": 1683,
	"./indicators/OTM_VWAP_FREE.jpg": 6135,
	"./instalation_mockup.jpg": 252,
	"./logoB.svg": 3109,
	"./logoOtm.png": 9759,
	"./logoW.svg": 9186,
	"./logo_ninja.png": 7676,
	"./logo_ninja_old.png": 6474,
	"./magnif_logo.png": 6316,
	"./micro_icon.png": 7196,
	"./mockup.png": 2185,
	"./next_log.png": 9488,
	"./otm_01.png": 9500,
	"./otm_02.png": 183,
	"./otm_live_02.gif": 5261,
	"./pack_mini.png": 2485,
	"./pay.png": 1320,
	"./paypal.png": 7137,
	"./paypal_button.png": 4802,
	"./performance_01.gif": 6527,
	"./profile_icon.png": 6477,
	"./results/22_12_12_en.png": 6779,
	"./results/22_12_12_en_old.png": 657,
	"./results/22_12_12_es.png": 3598,
	"./results/22_12_12_es_old.png": 1548,
	"./results/22_12_14_en.png": 5845,
	"./results/22_12_14_en_old.png": 1347,
	"./results/22_12_14_es.png": 9040,
	"./results/22_12_14_es_old.png": 894,
	"./results/22_12_14_es_old2.png": 4302,
	"./results/22_12_15_en.png": 2726,
	"./results/22_12_15_en_old.png": 1380,
	"./results/22_12_15_es.png": 5075,
	"./results/22_12_15_es_old.png": 4953,
	"./results/23_02_22_en.png": 6860,
	"./results/23_02_22_en_old.png": 3994,
	"./results/23_02_22_es.png": 3257,
	"./results/23_02_22_es_old.png": 8516,
	"./results/23_02_23_en.png": 1115,
	"./results/23_02_23_en_old.png": 4209,
	"./results/23_02_23_es.png": 9502,
	"./results/23_02_23_es_old.png": 9836,
	"./results/results_2022.gif": 5905,
	"./review/rev_fedver.jpeg": 7260,
	"./review/rev_gusloi.jpeg": 4847,
	"./review/rev_wilfra.jpeg": 8479,
	"./sp.png": 6681,
	"./swing_icon.png": 6174,
	"./telegrama.png": 7092,
	"./vecteezy_blue-background_AW1120.eps": 3720,
	"./visa.png": 3819,
	"./vp_mini.png": 3218,
	"./vwap_icon.png": 8940,
	"./youtube.png": 4321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;